import { useEffect } from "react";
import { trapTabKey } from "@/lib/focusTrap";

export default function PaymentFocusBoundary() {
  useEffect(() => {
    let activeDialog = null;
    let focusFrame = null;

    const handleKeyDown = (event) => {
      if (!activeDialog?.isConnected) return;
      trapTabKey(event, activeDialog);
    };

    const syncDialog = () => {
      const nextDialog = document.getElementById("payment-result");
      if (nextDialog === activeDialog) return;

      activeDialog = nextDialog;
      if (!activeDialog) return;

      if (!activeDialog.hasAttribute("tabindex")) activeDialog.setAttribute("tabindex", "-1");
      activeDialog.classList.add("tk-dialog-focus-target");
      if (focusFrame) window.cancelAnimationFrame(focusFrame);
      focusFrame = window.requestAnimationFrame(() => activeDialog?.focus?.());
    };

    syncDialog();
    const observer = new MutationObserver(syncDialog);
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      if (focusFrame) window.cancelAnimationFrame(focusFrame);
      observer.disconnect();
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return null;
}
